<template>
  <div :class="isShowing ? 'appear' : ''" :style="{display: isShowing ? 'block' : 'none', position:'fixed','z-index':1,left:0,top:0,width:'100%',height:'100%',overflow:'auto','background-color':'rgba(0,0,0,0.7)'}">
		<div style="display:flex;justify-content:center;">
			<div class="content" :style="[styleContent, {'margin-top':marginTop + 'px'}]">
				<span style="color:#aaa;float:right;padding-right:10px;font-size:28px;font-weight:bold;cursor:pointer;" @click="OnClose">&times;</span>
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
		marginTop:Number,
		isShowing:Boolean
	},
	methods: {
		OnClose: function() {
			this.$emit('update:isShowing', false);
			this.$emit('OnClose');
		}
	},
	data() {
		return {
			styleContent : {
				'height':'95vh',
				'overflow':'auto',
				'box-shadow':'0 2px 15px 0 rgba(16, 37, 133, 0.5)',
				'border-radius':'4px 4px 4px 4px',
				'background-color':'rgba(255, 255, 255, 1)'
			}
		}
	},
}
</script>

<style scoped>
.content {
	min-width: 60vw;
}
@media all and (max-width: 640px) {
  .content {
    width: 95vw;
  }
}
</style>
